import React, { useState, useEffect } from "react";
import { Col, Typography, Row, Tag } from "antd";
import { EyeFilled } from "@ant-design/icons";
import "../candidateskillisting.css";
import moment from "moment";
import history from "../../../../routes/history";


const SkillCard = (props) => {
  
  let userProfile1 = JSON.parse(localStorage.getItem("userProfile"));

  const { Text } = Typography;

  const detailHandler = () => {
    history.push({
      pathname: `/profiledetail/${props?.SkillListingId}`,
      state: {
        id: props?.SkillListingId,
        fromMatches: false,
        token: true
      },
    });
  }
  return (
    // 
    
    <Col  className="skills-card" onClick={detailHandler} >
       <div className="div-style" > <span className="skill-title">{props?.Title}</span></div>
        {/* <div className="location div-style">{props?.Location[0]?.LocationWithCountry}</div> */}
        {
          props?.SkillListings_Cities?.length>0 ?
          <div className="location div-style">
            {props?.SkillListings_Cities.map((item,index)=>{
            return(
            item?.Cities?.LocationWithCountry ? 
              <>{index!=0?', ':null} {item?.Cities?.LocationWithCountry}</>
              :
              item?.Cities?.CityName ? 
              <>{index!=0?', ':null}{item?.Cities?.CityName}, {item?.Cities?.CityCode}</>
              : 'Location N/A'
            
            )
          })}
          </div>
          :null
        }
      {
        // props?.Profiles?.Professions?.ProfessionCode=="IT"&&
        userProfile1?.Professions?.ProfessionCode=="HC"&&
        <div className="salary div-style">
        {/* Desired salary {parseInt(props?.MinimumBid)}/{"Year"} */}
        Desired salary {props?.MinimumBid?.toLocaleString('en-US')}/{props?.MinimumBidType=== "Hour" ? "HR" : props?.MinimumBidType === "Yearly" || props?.MinimumBidType === "Year" ? "YR" : props?.MinimumBidType === "Week" || props?.MinimumBidType === "Weekly" ? "WK" : "YR"}
        {/* {props?.MinimumBidType} */}
      </div>}

        <div style={{display:'flex', justifyContent:'space-between'}}>
          <div>
            <Tag className="skill-tag">{props?.SkillListingStatuses?.SkillListingStatusName}</Tag>
          </div>
          <div className="day-ago" >
            {moment(props?.Created).fromNow()}
          </div>
        </div>
        <Row>
          <Col style={{ marginTop: "2%", color: "#118936" }}>
            <div>
              <EyeFilled style={{ color: "#118936", padding: "2.3px 4.1px" }} />
              {props?.views ? props?.views.length : 0}
            </div>
          </Col>
          <Col style={{ marginTop: "2%", color: "#118936" }}>
            <div style={{ marginLeft: "10px" }}>{props?.bids} bids</div>
          </Col>
        </Row>
      </Col>
   
  );
};
export default SkillCard;
